import { Result, success } from "./index";
import isSuccess from "./isSuccess";

const map =
  <E, A, B>(fn: (a: A) => B) =>
  (result: Result<E, A>): Result<E, B> =>
    isSuccess(result) ? success(fn(result.value)) : result;

export default map;
